import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Products from './components/Products';
import SearchResults from './components/SearchResults';
import Cart from './components/Cart';
import AdminLogin from './components/AdminLogin';
import LoginForm from './components/LoginForm';
import ProductManager from './components/ProductManager';
import ProductEdit from './components/ProductEdit';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { auth, analytics } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { logEvent } from 'firebase/analytics';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);

  useEffect(() => {
    // Initialize Firebase Analytics
    logEvent(analytics, 'page_view', {
      page_title: 'Kid\'s Vibes - Premium Children\'s Accessories',
      page_location: window.location.href
    });

    const adminEmails = ["jeffwayne436@gmail.com"];
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setIsAdmin(currentUser && adminEmails.includes(currentUser.email));
      setLoading(false);
      
      // Track user authentication
      if (currentUser) {
        logEvent(analytics, 'login', {
          method: 'email'
        });
      }
    });
    return () => unsubscribe();
  }, []);

  // Handle loading screen timing
  useEffect(() => {
    // Show loading screen for at least 2.5 seconds for brand exposure
    const timer = setTimeout(() => {
      setShowLoadingScreen(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  // Show loading screen while initializing or during brand exposure period
  if (loading || showLoadingScreen) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <div className="App">
        <Navbar user={user} isAdmin={isAdmin} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={user ? <div style={{padding:40, textAlign:'center'}}><h2>Welcome back!</h2><p>You are already logged in as {user.email}</p></div> : <LoginForm />} />
          <Route path="/admin" element={isAdmin ? <ProductManager /> : <AdminLogin onLogin={() => setIsAdmin(true)} />} />
          <Route path="/admin/products" element={isAdmin ? <ProductManager /> : <AdminLogin onLogin={() => setIsAdmin(true)} />} />
          <Route path="/admin/add" element={isAdmin ? <ProductEdit /> : <AdminLogin onLogin={() => setIsAdmin(true)} />} />
          <Route path="/admin/edit/:id" element={isAdmin ? <ProductEdit /> : <AdminLogin onLogin={() => setIsAdmin(true)} />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
